import React from 'react';
import PropTypes from 'prop-types';
import TTSourceInput from './c/ttSourceInput/TTSourceInputConnector';
import TTTargetInput from './c/ttTargetInput/TTTargetInputConnector';
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import TTManageMappingList from '../../../ttManageMappingList/TTManageMappingListConnector';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from '../../../../../../constants/SharedConstants';
import LinearProgress from 'material-ui/LinearProgress';

class TTMainGrid extends React.Component {
  state = {
    listSlidingPanelOpen: false,
    selectedListSourceInputId: 0
  };

  handleCloseClick = id => this.props.ttActions.deleteRow(id, this.props.translationTableId);

  handleListClick = (selectedListSourceInputId) => {
    this.setState({
      listSlidingPanelOpen: true,
      selectedListSourceInputId
    });
    this.props.ttActions.fetchMatchColListItem(selectedListSourceInputId);
  };

  handleCloseListSlidingPanel = () => this.setState({ listSlidingPanelOpen: false });

  handleSaveListClick = () => {
    this.props.ttActions.saveMatchColList(this.state.selectedListSourceInputId);
    this.handleCloseListSlidingPanel();
  };

  handleConfirmDialog = () => {
    this.props.ttActions.cancelMatchColList(this.state.selectedListSourceInputId);
    this.handleCloseListSlidingPanel();
  };

  render() {
    const { sourceColumns, targetColumn, rows, changingColList, fetchingTranslationTableData } = this.props;
    const { listSlidingPanelOpen, selectedListSourceInputId } = this.state;
    const selectedListSourceInput = this.props.lists.find(list => (list.sourceInputId === this.state.selectedListSourceInputId));
    const saveListDisabled = (!selectedListSourceInput || (selectedListSourceInput && selectedListSourceInput.items.length < 2) || changingColList);
    return (
      <React.Fragment>
        {
          fetchingTranslationTableData &&
          <LinearProgress mode="indeterminate" />
        }
        {
          !fetchingTranslationTableData &&
          <div className={ 'tt-main-grid' }>
            {
              rows.map((row, rowIndex) => (
                <div key={ rowIndex } className={ 'tt-main-grid__row' }>
                  {
                    sourceColumns.map((sourceColumn, index) => (
                      <div key={ row.sourceInputs[index].id } className={ 'tt-main-grid__source-column' }>
                        <TTSourceInput
                          sourceInput={ row.sourceInputs[index] }
                          sourceColumn={ sourceColumn }
                          displayClose={ index===0 && rows.length > 1 }
                          onCloseClick={ () => this.handleCloseClick(row.targetInput.id) }
                          onListClick={ () => this.handleListClick(row.sourceInputs[index].id) }
                        />
                      </div>
                    ))
                  }
                  <div className={ 'tt-main-grid__spacer' } />
                  <div className={ 'tt-main-grid__target-column' }>
                    {
                      <TTTargetInput targetInput={ row.targetInput } targetColumn={ targetColumn }/>
                    }
                  </div>
                </div>
              ) )
            }
          </div>
        }
        <SovosEditableSlidingPanel
          isDirty={ () => true }
          contentStyle={ { padding: 0 } }
          open={ listSlidingPanelOpen }
          onClose={ this.handleConfirmDialog }
          baseWidth={ '1080px' }
          title={ "Manage Mapping List" }
          SaveButtonProps={ {
            disabled: saveListDisabled,
            onClick: this.handleSaveListClick,
            className: 'tt-main-grid__button'
          } }
          CancelButtonProps={
            {
              className: 'tt-main-grid__button',
              children: 'CANCEL'
            }
          }
          CloseDialogProps={ {
            DialogTitleProps: {
              children: SLIDING_PANEL_DIALOG_TITLE,
              className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
            },
            DialogContentProps: {
              children: SLIDING_PANEL_DIALOG_TEXT,
              className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
            },
            OKButtonProps: {
              children: SLIDING_PANEL_DIALOG_ACTION_LABEL
            },
            CancelButtonProps: {
              children: 'CANCEL'
            }
          } }
        >
          <TTManageMappingList sourceInputId={ selectedListSourceInputId } />
        </SovosEditableSlidingPanel>
      </React.Fragment>
    );
  }
}


TTMainGrid.propTypes = {
  translationTableId: PropTypes.number.isRequired,
  sourceColumns: PropTypes.array.isRequired,
  targetColumn: PropTypes.object,
  rows: PropTypes.array.isRequired,
  lists: PropTypes.array.isRequired,
  changingColList: PropTypes.bool.isRequired,
  ttActions: PropTypes.shape({
    deleteRow: PropTypes.func,
    createMatchColListItem: PropTypes.func,
    fetchMatchColListItem: PropTypes.func,
    saveMatchColList: PropTypes.func,
    cancelMatchColList: PropTypes.func
  }).isRequired,
  translationTableEditionMode: PropTypes.bool,
  fetchingTranslationTableData: PropTypes.bool
};

export default TTMainGrid;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttRowManager/c/ttMainGrid/ttMainGrid.js